
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Reviews from './components/Reviews';
import CTA from './components/CTA';
import Contact from './components/Contact';
import FAQ from './components/FAQ';
import Sectors from './components/Sectors';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <Products />
      <Reviews />
      <CTA />
      <Sectors />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
